
export default function Mission() {
  const missions = [
    {
      icon: 'ri-microscope-line',
      title: '研究',
      subtitle: 'Research',
      description: '研究有關工商企業各項問題',
      color: 'purple'
    },
    {
      icon: 'ri-hand-heart-line',
      title: '友誼',
      subtitle: 'Friendship',
      description: '增進工商青年之友誼與合作',
      color: 'orange'
    },
    {
      icon: 'ri-service-line',
      title: '服務',
      subtitle: 'Service',
      description: '培養健全人格服務社會人群',
      color: 'green'
    }
  ];

  return (
    <section id="about" className="py-16 sm:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="mb-10 sm:mb-16 text-center sm:text-left">
          <p className="text-xs sm:text-sm font-light text-gray-500 mb-2 sm:mb-3 tracking-wider uppercase">Our Mission</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-purple-900 tracking-wide">
            研究 · 友誼 · 服務
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {missions.map((mission, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
            >
              <div className={`w-12 sm:w-16 h-12 sm:h-16 flex items-center justify-center rounded-xl sm:rounded-2xl bg-${mission.color}-50 mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${mission.icon} text-2xl sm:text-3xl text-${mission.color}-600 w-6 sm:w-8 h-6 sm:h-8 flex items-center justify-center`}></i>
              </div>
              
              <h3 className="text-xl sm:text-2xl font-bold text-purple-900 mb-1 sm:mb-2">
                {mission.title}
              </h3>
              <p className="text-xs sm:text-sm font-light text-orange-600 mb-3 sm:mb-4 tracking-wide">
                {mission.subtitle}
              </p>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {mission.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
